import { useEffect, useState } from "react";
import { HttpTransportType, HubConnectionBuilder } from "@microsoft/signalr";
import useToken from "../useToken";


export const TestSignalR = () => {
    const [connection, setConnection] = useState(null);
    const { token } = useToken();
    const { datab1, setDatab1 } = useState();
    const { datab2, setDatab2 } = useState();

    useEffect(() => {
        const newConnection = new HubConnectionBuilder()
            .withUrl("/visitorlisthub", {
                headers: {
                    Authorization: "Bearer " + token,
                },
                transport: HttpTransportType.LongPolling
            })
            .withAutomaticReconnect()
            .build()
        setConnection(newConnection)
    }, [])

    useEffect(() => {
        if (connection) {
            connection.on("ReceiveMessage", (data1, data2) => {
                // console.log(data1, data2)
                console.log(data1)
                setDatab1(data1)
                setDatab2(data2)
            });

            console.log(connection)
            connection.start({ transport: 'longPollin' }).then(() => {
                console.log("Connected!");
            });
            console.log(connection)

            return () => connection.stop();
        }

    }, [connection]);

    useEffect(() => {
        console.log(datab1, datab2)
    }, [datab1, datab2])

    const sendMessage = () => { connection.invoke("SendMessage", "Admin", "Hello world").catch((err) => console.error(err)) }


    return (
        <div>
            <button onClick={() => { sendMessage() }}> Test</button>
            {
                datab1 ?
                    <div>
                        <div>{datab1}</div>
                        <div>{datab2}</div>
                    </div > : <div></div>
            }
        </div>
    )
}